import React from 'react';
import SignatureBox from '../SignatureBox';
import css from '../PickupModal.css';

const SignatureStep = ({
  signProtocolInProgress,
  signProtocolSuccess,
  signProtocolError,
  handleSignProtocol,
  protocolType,
  txId,
  protocol,
  onBack,
}) => {
  return (
    <>
      <h2>Podpis klienta</h2>
      <div className={css.signatureBox}>
        <div className={css.signaturePlaceholder}>
          <SignatureBox
            signProtocolInProgress={signProtocolInProgress}
            signProtocolSuccess={signProtocolSuccess}
            signProtocolError={signProtocolError}
            handleSignProtocol={handleSignProtocol}
            protocolType={protocolType}
            txId={txId}
            protocolKey={protocolType === 'pickup' ? protocol.pickupSignKey : (protocol.returnSignKey || protocol.deliverSignKey)}
          />
        </div>
      </div>
      <div className={css.actions}>
        <a type="button" onClick={onBack} className={css.back}>
          Wstecz
        </a>
      </div>
    </>
  );
};

export default SignatureStep;
